import {
  StyledDialog,
  StyledDialogTitle,
  StyledDialogContent,
  StyledDialogContentText,
  StyledDialogActions,
  StyledDialogAction,
} from './styled';

type PropsType = {
  isOpen: boolean;
  onClose: () => void;
};

const SuccessDialog = ({ isOpen, onClose }: PropsType) => {
  return (
    <StyledDialog open={isOpen} onClose={onClose}>
      <StyledDialogTitle>Success!</StyledDialogTitle>
      <StyledDialogContent>
        <StyledDialogContentText>
          Thanks for your payment.
        </StyledDialogContentText>
      </StyledDialogContent>
      <StyledDialogActions>
        <StyledDialogAction onClick={onClose}>Continue</StyledDialogAction>
      </StyledDialogActions>
    </StyledDialog>
  );
};

export default SuccessDialog;
